import { SettingConst } from '@faire/web-api--source/types';

/**
 * controls whether a NAM retailer receives random initial terms limit
 */
export const NAM_BM_SIGNUP_LIMIT_FOUNDATIONAL_EXPERIMENT_221010 =
  'NAM_BM_SIGNUP_LIMIT_FOUNDATIONAL_EXPERIMENT_221010' as SettingConst<
    'NAM_BM_SIGNUP_LIMIT_FOUNDATIONAL_EXPERIMENT_221010',
    boolean,
    never
  >;
